import { useParams } from 'react-router';
import { PurchaseOrderBundle } from '../api/contracts/catalog/bundles';
import { usePurchaseOrderBundles } from '../api/hooks/bundles';
import { useMemo } from 'react';
import { PoStatus } from './usePurchaseOrderService';

export const usePurchaseOrders = (mspId: string, customerId: string) => {
  const [orders] = usePurchaseOrderBundles(mspId, customerId);

  return orders;
};

export const useDraftPurchaseOrders = (mspId: string, customerId: string) => {
  const allOrders = usePurchaseOrders(mspId, customerId);

  return useMemo(() => allOrders.filter(order => order.state === PoStatus.Draft), [allOrders]);
};

export const useInProgressPurchaseOrders = (mspId: string, customerId: string) => {
  const allOrders = usePurchaseOrders(mspId, customerId);

  return useMemo(
    () => allOrders.filter(order => order.state !== PoStatus.Complete && order.state !== PoStatus.Draft),
    [allOrders]
  );
};

export const useCompletedPurchaseOrders = (mspId: string, customerId: string) => {
  const allOrders = usePurchaseOrders(mspId, customerId);

  return useMemo(() => allOrders.filter(order => order.state === PoStatus.Complete), [allOrders]);
};

export const usePurchaseOrder = (orderId?: string) => {
  const { companyId, partnerId } = useParams<{ companyId: string; partnerId: string }>();

  if (!(companyId && partnerId)) {
    throw Error('Missing page parameter');
  }

  const orders = usePurchaseOrders(partnerId, companyId);

  if (!orderId) return;

  const order: PurchaseOrderBundle | undefined = orders.find(order => order.id === orderId);

  return order;
};
